import { Button } from "@material-ui/core";
import { toJS } from "mobx";
import { observer } from "mobx-react";
import React, { Fragment } from "react";
import Prompt from "../../components/Prompt";
import adminStore from "../../stores/adminStore";
import DataTable from "./../../components/DataTable";
import Confirm from "../../components/Confirm";

@observer
class Competences extends React.Component {
  state = {
    isPromptOpened: false,
    isConfirmOpened: false,
    activeCompetence: {},
  };

  closeModal() {
    this.setState({
      isPromptOpened: false,
      isConfirmOpened: false,
      activeCompetence: {},
    });
  }

  render() {
    const { competences } = adminStore;
    if (!competences) {
      return <div></div>;
    }
    return (
      <Fragment>
        <Button
          variant="contained"
          color="primary"
          onClick={() =>
            this.setState({ isPromptOpened: true, activeCompetence: {} })
          }
        >
          Nueva Competencia
        </Button>
        <Prompt
          isOpen={this.state.isPromptOpened}
          field={{
            type: "text",
            label: "Competencia",
            value: this.state.activeCompetence.name,
          }}
          placeholder={this.state.activeCompetence.name}
          title={"Area"}
          onClose={this.closeModal}
          onSubmit={async (name) => {
            await adminStore.submitCompetence({
              ...this.state.activeCompetence,
              name,
            });
            this.closeModal();
          }}
        />
        <Confirm
          isOpen={this.state.isConfirmOpened}
          onNo={() => this.closeModal()}
          onYes={async () => {
            await adminStore.deleteCompetence(this.state.activeCompetence.id);
            this.closeModal();
          }}
          onClose={() => this.closeModal()}
          title="Atencion"
          text={`Esta accion borrar a la competencia ${this.state.activeCompetence.name}, desea continuar?`}
        />
        <DataTable
          data={competences}
          fields={["id", "name"]}
          fieldNames={{
            id: "#",
            name: "Nombre",
          }}
          onEdit={(comp) => {
            this.setState({
              isPromptOpened: true,
              activeCompetence: toJS(comp),
            });
          }}
          onDelete={(comp) =>
            this.setState({
              isConfirmOpened: true,
              activeCompetence: comp,
            })
          }
        />
      </Fragment>
    );
  }
}

export { Competences };
